"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for when no subscription exists when fetching/enrolling
 * in a premium course
 * @param {string} message
 */
class SubscriptionNotFoundError extends client_library_1.ExtendableError {
    constructor(message) {
        super(message);
    }
}
exports.default = SubscriptionNotFoundError;
//# sourceMappingURL=SubscriptionNotFoundError.js.map